/* eslint-disable max-depth, no-nested-ternary */

import {CSSObject} from '@mui/material';
import {FC} from 'react';
import {Box} from '../../Box';
import {Divider} from '../../Divider';
import {Typography} from '../../Typography/Typography';
import {useFileInputContext} from '../FileInputContext';
import {getFileStatusIcon} from '../utils/getFileStatusIcon';
import HelpIcon from '@mui/icons-material/Help';
import {Tooltip} from '../../Tooltip';

export const FileInputValidationsPanel: FC<unknown> = () => {
    const {
        validations, validators, textMap, showHelperText
    } = useFileInputContext();

    // init, checking if any validations have been added before
    // looping through validators

    let hasStatus = false;
    const checksObject: Record<string, boolean> = {};

    if (Array.isArray(validations) && validations.length > 0) {
        hasStatus = true;

        // loop through validations
        for (const validation of validations) {
            for (const check of Object.keys(validation.checks)) {
                // if check exists and not false
                if (!checksObject.hasOwnProperty(check)) {
                    checksObject[check] = true;
                }

                if (Boolean(checksObject[check]) !== false) {
                    checksObject[check] = validation.checks[check];
                }
            }
        }
    }

    return (
        <div>
            {textMap.validationTitle && (
                <>
                    <Box
                        alignItems='center'
                        display='flex'
                        marginTop='0.75rem'
                    >
                        <Typography
                            marginRight='0.25rem'
                            variant='subtitle1'
                        >{textMap.validationTitle}</Typography>
                        {showHelperText && (
                            <Tooltip title={textMap.validationSupplement}>
                                <HelpIcon
                                    color='action'
                                    sx={{
                                        fontSize: '1rem'
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                    <Divider
                        sx={(theme): CSSObject => ({
                            marginBottom: theme.tokens.FuelSpacing1
                        })}
                    />
                </>
            )}
            {validators.map((validator) => (
                <Box
                    alignItems='center'
                    display='flex'
                    key={validator.key}
                    marginBottom='0.375rem'
                >
                    {getFileStatusIcon(
                        !hasStatus ?
                            'unvalidated' :
                            checksObject[validator.key] ?
                                'success' :
                                'error',
                        textMap
                    )}
                    <Typography
                        display='block'
                        marginLeft='0.25rem'
                        noWrap
                        variant='body2'
                    >
                        {validator.displayText}
                    </Typography>
                </Box>
            ))}
        </div>
    );
};
